import type { RoleUpgradeStatusFilter } from "../members.types";
import { baseApi } from "@/app/store/baseApi";
import type { Profile } from "@/app/profile/profile.types";
import type {
  RoleUpgradeRequestListItem,
  RoleUpgradeDecisionRequest,
  RoleUpgradeDecisionResponse,
} from "../members.types";

export const membersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listRoleUpgradeRequests: builder.query<RoleUpgradeRequestListItem[], RoleUpgradeStatusFilter | undefined>({
      query: (status) => {
        const params = new URLSearchParams();
        if (status) params.set("status", status);
        return {
          url: "/admin/role-upgrade-requests",
          method: "GET",
          params,
          auth: true,
        };
      },
      providesTags: (requests) =>
        requests
          ? [{ type: "RoleUpgradeRequest" as const, id: "LIST" }, ...requests.map((r) => ({ type: "RoleUpgradeRequest" as const, id: r.userId }))]
          : [{ type: "RoleUpgradeRequest" as const, id: "LIST" }],
    }),
    getAdminUserProfile: builder.query<Profile, string>({
      query: (userId) => ({
        url: `/admin/users/${userId}/profile`,
        method: "GET",
        auth: true,
      }),
      providesTags: (result, error, userId) => [{ type: "Profile" as const, id: userId }],
    }),
    upgradeUserRole: builder.mutation<RoleUpgradeDecisionResponse, { userId: string; body: RoleUpgradeDecisionRequest }>({
      query: ({ userId, body }) => ({
        url: `/admin/users/${userId}/role-upgrade`,
        method: "POST",
        body,
        auth: true,
      }),
      invalidatesTags: [{ type: "RoleUpgradeRequest", id: "LIST" }],
    }),
  }),
});

export const { useListRoleUpgradeRequestsQuery, useGetAdminUserProfileQuery, useUpgradeUserRoleMutation } = membersApi;
